/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} House_House_Mongoose_CoaxInputs */

const fr_house_house_mongoose_coax = /** @type {(inputs: House_House_Mongoose_CoaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil - Notifications`)
};

/**

* @param {House_House_Mongoose_CoaxInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const house_house_mongoose_coax = /** @type {((inputs?: House_House_Mongoose_CoaxInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<House_House_Mongoose_CoaxInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_house_house_mongoose_coax(inputs)
});